"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var ProductionTypeResource = /** @class */ (function (_super) {
    tslib_1.__extends(ProductionTypeResource, _super);
    function ProductionTypeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductionTypeResource.endpoint = '/productiontypes';
    ProductionTypeResource.MODEL_NAME = 'productiontype';
    return ProductionTypeResource;
}(base_1.default));
exports.default = ProductionTypeResource;
//# sourceMappingURL=productiontype.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/productiontype.js
// module id = wI0k
// module chunks = 0